import { render, staticRenderFns } from "./IOTStartupActivities.vue?vue&type=template&id=7a4f22f9"
import script from "./IOTStartupActivities.vue?vue&type=script&lang=js"
export * from "./IOTStartupActivities.vue?vue&type=script&lang=js"
import style0 from "./IOTStartupActivities.vue?vue&type=style&index=0&id=7a4f22f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports